import React from 'react';
import { Pager } from '@progress/kendo-react-data-tools';
import { KendoPagerProps } from './types';
import './KendoGrid.css';

export const KendoPager: React.FC<KendoPagerProps> = ({
  skip,
  take,
  total,
  onPageChange,
  pageSizes = [10, 20, 50, 100],
  buttonCount = 5,
  info = true,
  previousNext = true,
  responsive = true,
}) => {
  return (
    <Pager
      responsive={responsive}
      skip={skip}
      take={take}
      total={total}
      onPageChange={onPageChange}
      buttonCount={buttonCount}
      info={info}
      previousNext={previousNext}
      type="numeric"
      pageSizes={pageSizes}
    />
  );
};
